import * as React from 'react';
import { certificationIconSize } from '../common/Style';
import { generateId, Id } from '../common/Id';
import { Messages } from '../../gen-src/Localize';

/**
 * Test id attribute value (prefix) for certification icon component.
 */
export const certificationIconTestId: Id = 'certification-icon';

// TODO replace base 64 encoded image with shared asset
// tslint:disable-next-line
export const certificationIconSource = 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgd2lkdGg9IjI0cHgiIGhlaWdodD0iMTlweCIgdmlld0JveD0iMCAwIDI0IDE5IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNCAxOTsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwYXRoIHN0eWxlPSJmaWxsOiM2NjY2NjY7IiBkPSJNMTQsMTB2Ni41bC0yLjEtMC45bC0wLjQtMC4ybC0wLjQsMC4yTDksMTYuNVYxMEgxNCBNMTUsOUg4djlsMy41LTEuNEwxNSwxOFY5TDE1LDl6Ii8+DQoJPC9nPg0KCTxnPg0KCQk8Y2lyY2xlIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBjeD0iMTEuNSIgY3k9IjcuNSIgcj0iNSIvPg0KCQk8cGF0aCBzdHlsZT0iZmlsbDojNjY2NjY2OyIgZD0iTTExLjUsM0MxNCwzLDE2LDUsMTYsNy41UzE0LDEyLDExLjUsMTJTNywxMCw3LDcuNVM5LDMsMTEuNSwzIE0xMS41LDJDOC41LDIsNiw0LjUsNiw3LjUNCgkJCVM4LjUsMTMsMTEuNSwxM2MzLDAsNS41LTIuNSw1LjUtNS41UzE0LjUsMiwxMS41LDJMMTEuNSwyeiIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg==';

/**
 * Props for certification icon component.
 */
export interface CertificationIconProps {
  id?: Id;
}

/**
 * Certification icon component.
 * @param props - The props for this certification icon.
 */
export function CertificationIconComponent(
  props: CertificationIconProps & React.HTMLProps<HTMLImageElement>
): React.ReactElement<CertificationIconProps> {
  return <img
    data-tb-test-id={generateId(certificationIconTestId, props.id)}
    className={props.className}
    style={props.style}
    width={certificationIconSize}
    height={certificationIconSize}
    src={certificationIconSource}
    alt={Messages.CertificationIcon()}
  />;
}
